"use client"

import { AppWindow } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AppWindowIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AppWindowIcon = component(Icon)({ as: AppWindow })
